import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { PromiseCompletionSource } from "scene-manager";
import { Viewable } from "scene-manager";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { LoseSceneResourcesPackage } from "./resources/LoseSceneResourcesPackage";
import { LoseController } from "./controller/LoseController";
import { LoseSceneView } from "./views/ext/LoseSceneView";
import { NewBestScoreLoseSceneView } from "./views/ext/NewBestScoreLoseSceneView";
import { Localization } from "../common/Localization";
import { AudioManager } from "../../audio/AudioManager";

@injectable()
export class LoseScene extends Viewable<void> {
    public constructor(
        @inject(InjectableInterfaces.ICanvasScaler) private readonly canvasScaler: ICanvasScaler,
        private readonly loseSceneResourcesPackage: LoseSceneResourcesPackage,
        private readonly loseController: LoseController,
        private readonly localization: Localization,
        private readonly audioManager: AudioManager
    ) {
        super();
    }

    @initializer()
    public async initialize(): Promise<void> {
        const sceneCanBeClosed = new PromiseCompletionSource<void>();
        if (this.loseController.getPlayerScore() < this.loseController.getBestScore()) {
            this.view = new NewBestScoreLoseSceneView(
                this.canvasScaler,
                this.loseSceneResourcesPackage,
                this.loseController,
                this.localization,
                this.audioManager,
                sceneCanBeClosed
            );
            this.loseController.setBestScore(this.loseController.getPlayerScore());
        } else {
            this.view = new LoseSceneView(
                this.canvasScaler,
                this.loseSceneResourcesPackage,
                this.loseController,
                this.localization,
                this.audioManager,
                sceneCanBeClosed
            );
        }
        sceneCanBeClosed.result.then(() => {
            this.operationControls.complete();
        });
    }
}